import { Component } from '@angular/core';
import {AuthService} from "../../../Services/auth.service";
import {NavigationEnd, Router} from "@angular/router";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css']
})
export class TopMenuComponent {

  name: string;
  constructor(private authService: AuthService, private router: Router) {}
  private routerSubscription: Subscription;

  menuNavExpanded: boolean = false;

  toggleNavOpen() {
    this.menuNavExpanded = !this.menuNavExpanded
  }


  closeNavbar() {
    this.menuNavExpanded = false;
  }

  currentUrl: string;
  ngOnInit(): void {

    this.name = this.authService?.getDisplayName();
    this.currentUrl = this.router.url;
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeNavbar();  
      }
    });
  }
  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
